import React, { useEffect, useState, useRef } from "react";
import Projectheader from "./../../../assets/blogpage.webp";

const BlogHeader = () => {
  const text = "Our Architectural Masterpieces";
  const [isVisible, setIsVisible] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    // Define keyframes dynamically
    const fadeInKeyframes = `
      @keyframes fadeInHeader {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    // Inject keyframes into the document head
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = fadeInKeyframes;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    // IntersectionObserver to detect when 30% of the header is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (headerRef.current) observer.observe(headerRef.current);

    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current);
    };
  }, []);

  return (
    <header ref={headerRef} style={styles.headerContainer}>
      <div style={styles.overlay}>
        <h1
          style={{
            ...styles.heading,
            opacity: isVisible ? 1 : 0,
            animation: isVisible ? "fadeInHeader 1s ease-out forwards" : "none",
          }}
        >
          {text}
        </h1>
        <p
          style={{
            ...styles.subText,
            opacity: isVisible ? 1 : 0,
            animation: isVisible ? "fadeInHeader 1.5s ease-out forwards" : "none",
          }}
        >
          Discover stunning projects that redefine spaces and inspire the future. A curated collection of innovative designs and engineering excellence.
        </p>
      </div>
    </header>
  );
};

// Inline styles (fully responsive)
const styles = {
  headerContainer: {
    width: "100vw",
    height: "55vh", // Default height
    backgroundImage: `url(${Projectheader})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
    
    /* 🔹 Responsive height adjustments */
    "@media (max-width: 1024px)": { height: "50vh" },
    "@media (max-width: 768px)": { height: "60vh" },
    "@media (max-width: 480px)": { height: "70vh" }, 
  },
  overlay: {
    padding: "5%",
    borderRadius: "10px",
    maxWidth: "80%",
  },
  heading: {
    fontSize: "clamp(2.5rem, 5vw, 4rem)", // Responsive font size
    fontWeight: "bold",
    marginBottom: "10px",
    lineHeight: "1.2",
  },
  subText: {
    fontSize: "clamp(1rem, 2.5vw, 1.5rem)", // Responsive font size
    marginTop: "10px",
    maxWidth: "90%", // Prevents long lines on wider screens
    lineHeight: "1.4",
  },
};

export default BlogHeader;
